import axios from 'axios';
import { endpoints } from '@/api/endpoints.js';
import { baseURL } from '../../../api/environment';

const URL = baseURL;

// Helpers
const getCardNumber = (cardnumber) => {
    return cardnumber.replace(/ /g, '').replace(/-/g, '');
};

const getPhoneNumber = (phonenumber) => {
    return phonenumber.replace(/ /g, '').replace(/-/g, '');
};

const getCardType = (cardnumber) => { 
    const firstDigit = cardnumber.substring(0, 1);
    let cardType = "";
    switch (firstDigit) {
        case '3':
            cardType = "AMEX";
            break;
        case '4':
            cardType = "VISA";
            break;
        case '5':
            cardType = "Master Card";
            break;
        case '6':
            cardType = "DISCOVERY";
            break;
    }
    return cardType;
};

/**
 * Genera un ID de orden aleatorio
 */
export const generateRandomOrderId = () => {
    return Date.now();
};

/**
 * Genera la firma de pago
 */
export const generateSignaturePay = async ({ commit, rootState }) => {
    try {
        commit('SET_LOADING', true);
        const token = rootState.Token.token.dataObj;
        const product = rootState.Products.information;
        const total = parseInt(parseFloat(parseInt(product.suscripcion) * 100).toFixed(0));
        const orderId = generateRandomOrderId();
        const endpoint = endpoints.checkout.generateSignaturePay.endpoint + `/${total}/${orderId}`;

        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'get',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
        });

        data.dataObj.orderId = orderId;
        data.dataObj.total = total;

        commit('SET_REGISTER_SIGNATURE', data);
    } catch (err) {
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};

/**
 * Registra el método de pago seleccionado
 */
export const setRegisterMethod = async ({ commit, getters, rootState }, params) => {
    try {
        commit('SET_LOADING', true);
        const token = rootState.Token.token.dataObj;
        const endpoint = endpoints.checkout.registerMethod.endpoint;
        const subscriber = await getters.getFolio;
        
        console.log('🔍 setRegisterMethod - Datos recibidos:', params);
        console.log('🔍 setRegisterMethod - Folio:', subscriber);
        console.log('🔍 setRegisterMethod - Endpoint:', endpoint);
        
        let requestData = {};
        
        // Nuevo formato para Banamex con id_order
        if (params.metodo_pago && params.id_order) {
            requestData = {
                "folio": params.folio || subscriber.dataObj.folio,
                "metodo_pago": params.metodo_pago,
                "pago_suscripcion": params.pago_suscripcion,
                "id_order": params.id_order
            };
            console.log('🆕 Usando formato nuevo (Banamex con id_order)');
        }
        // Formato antiguo
        else {
            switch (params.paymentMethod) {
                case 'efectivo':
                    requestData = {
                        "folio": subscriber.dataObj.folio,
                        "metodo_pago": "Efectivo",
                        "pago_suscripcion": "centro-pago"
                    };
                    break;
                case 'paypal':
                    requestData = {
                        "folio": subscriber.dataObj.folio,
                        "metodo_pago": "Efectivo",
                        "pago_suscripcion": "PayPal"
                    };
                    break;
                case 'telmex':
                    requestData = {
                        "folio": subscriber.dataObj.folio,
                        "metodo_pago": "Recibo Telmex",
                        "numero_telmex": getPhoneNumber(params.telmex)
                    };
                    break;
                case 'card':
                    const isBanamex = params.card === '0000000000000000' || params.cardName === 'Banamex Payment';
                    const paymentProvider = isBanamex ? 'BANAMEX' : 'VICOMM';
                    
                    console.log('💳 Detectando proveedor de pago:', {
                        card: params.card,
                        cardName: params.cardName,
                        isBanamex,
                        paymentProvider
                    });
                    
                    requestData = {
                        "folio": subscriber.dataObj.folio,
                        "metodo_pago": "Tarjeta de crédito",
                        "nombre_titular_tarjeta": params.cardName || 'Titular',
                        "tipo_tarjeta": params.card ? getCardType(params.card) : 'N/A',
                        "numero_tarjeta": params.card ? getCardNumber(params.card) : '0000000000000000',
                        "pago_suscripcion": paymentProvider
                    };
                    break;
            }
        }
        
        console.log('📤 setRegisterMethod - Request Data:', requestData);
        
        const { data } = await axios.request({
            url: `${endpoint}`,
            method: 'post',
            baseURL: URL,
            responseType: 'json',
            headers: {
                'Authorization': token
            },
            data: {
                ...requestData
            }        
        });
        
        console.log('📥 setRegisterMethod - Response:', data);

        if (Object.keys(data.dataObj).length != 0) {
            if (data.dataObj.codigo_respuesta == 222) {
                console.error('❌ setRegisterMethod - Error 222:', data.dataObj.mensaje_respuesta);
                commit('SET_ERROR_SUBSCRIPTION', data.dataObj.mensaje_respuesta);
                commit('SET_LOADING', false);
                return data;
            } else {
                console.log('✅ setRegisterMethod - Registro exitoso');
                commit('SET_REGISTRATION_METHOD', data);
                return data;
            }
        } else {
            console.error('❌ setRegisterMethod - dataObj vacío:', data.msg);
            commit('SET_ERROR_SUBSCRIPTION', data.msg);
            commit('SET_LOADING', false);
        }
    } catch (err) {
        console.error('❌ setRegisterMethod - Exception:', err);
        commit('SET_ERROR_SUBSCRIPTION', err.message);
    } finally {
        commit('SET_LOADING', false);
    }
};
